import { Box, Text, VStack } from '@chakra-ui/react'
import Image from 'next/image'

export type ProductAdvantagesItemProps = {
  icon: string
  title: string
}

export const ProductAdvantagesItem = ({ icon, title }: ProductAdvantagesItemProps) => {
  return (
    <VStack height="7.875rem" minWidth={'163px'} width={'163px'}>
      <Box width={'60px'} height={'60px'}>
        <Image src={icon} width={60} height={60} quality={100} />
      </Box>
      <Text color="gray.700" textAlign="center" fontSize={{ sm: '0.75rem', md: '1.25rem' }}>
        {title}
      </Text>
    </VStack>
  )
}
